import { useMutation, useQueryClient } from "@tanstack/react-query";
import { postSubscribeBrand } from "src/api/brand";
import { QUERY_KEYS } from "../constants/queryKeys";
export const useSubscribeBrandMutation = ()=>{
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (variables)=>postSubscribeBrand(variables),
        onMutate: async (param)=>{
            let { name , isSubscribed  } = param;
            const queryKey = QUERY_KEYS.BRAND(name);
            await queryClient.cancelQueries({
                queryKey
            });
            const previousBrand = queryClient.getQueryData(queryKey);
            queryClient.setQueryData(queryKey, (old)=>{
                if (!old) return old;
                // 같은 상태 중복 호출 시 누적되지 않도록 실제 상태 변경 시에만 ±1
                const wasSubscribed = old.isSubscribed === true;
                const delta = wasSubscribed === isSubscribed ? 0 : isSubscribed ? 1 : -1;
                const subscriberCount = typeof old.subscriberCount === "number" ? Math.max(0, old.subscriberCount + delta) : old.subscriberCount;
                return {
                    ...old,
                    isSubscribed,
                    subscriberCount
                };
            });
            return {
                previousBrand
            };
        },
        onError: (_error, param, context)=>{
            let { name , isSubscribed  } = param;
            // 다른 mutation이 캐시를 덮어쓴 뒤라면 rollback 하지 않음
            queryClient.setQueryData(QUERY_KEYS.BRAND(name), (current)=>{
                if (!current) return current;
                if (current.isSubscribed !== isSubscribed) return current;
                var _context_previousBrand;
                return (_context_previousBrand = context === null || context === void 0 ? void 0 : context.previousBrand) !== null && _context_previousBrand !== void 0 ? _context_previousBrand : current;
            });
        },
        onSettled: (_data, _error, param)=>{
            let { name  } = param;
            queryClient.invalidateQueries({
                queryKey: QUERY_KEYS.BRAND(name)
            });
        }
    });
};
